var Wdot;
(function (Wdot) {
    var Share = (function () {
        function Share() {
        }
        Share.shareClick = function () {
            $('.js-social-overlay').removeClass('hidden');
        };
        Share.shareClose = function () {
            $('.js-social-overlay').addClass('hidden');
        };
        Share.email = function () {
            if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                Wdot.ModalHelpWindow.loadAjaxGet(300, 400, true, '/Help/EmailShare?referenceURL=' + window.location, function () {
                    document.getElementById("ScreenHeight").value = screen.height.toString();
                    document.getElementById("ScreenWidth").value = screen.width.toString();
                    document.getElementById("PageTitle").value = this.pageTitle.toString();
                }, null, null);
            }
            else {
                Wdot.ModalHelpWindow.loadAjaxGet(500, 550, true, '/Help/EmailShare?referenceURL=' + window.location, function () {
                    document.getElementById("ScreenHeight").value = screen.height.toString();
                    document.getElementById("ScreenWidth").value = screen.width.toString();
                    document.getElementById("PageTitle").value = this.pageTitle.toString();
                }, null, null);
            }
            Wdot.Share.trackShareEvent("Email", "Share", decodeURIComponent(this.url));
            Wdot.Share.shareClose();
        };
        Share.tweet = function () {
            var tweetUrl = "";
            var region = "";
            var county = "";
            var city = "";
            var placeName = "";
            var categoryName = "";
            var name = "";
            var type = "";
            tweetUrl = 'https://twitter.com/share?text=' + this.pageTitle + ' @TravelWI&url=' + this.url;
            if ($('meta[name=tw_region]').attr("content")) {
                region = ($('meta[name=tw_region]').attr("content"));
            }
            if ($('meta[name=tw_county]').attr("content")) {
                county = ($('meta[name=tw_county]').attr("content"));
            }
            if ($('meta[name=tw_city]').attr("content")) {
                city = ($('meta[name=tw_city]').attr("content"));
            }
            if ($('meta[name=tw_name]').attr("content")) {
                placeName = ($('meta[name=tw_name]').attr("content")).replace(/&amp;/g, '%26');
            }
            if ($('meta[name=tw_categoryName]').attr("content")) {
                categoryName = ($('meta[name=tw_categoryName]').attr("content")).replace(/&amp;/g, '%26');
            }
            if ($('meta[name=tw_name]').attr("content")) {
                name = ($('meta[name=tw_name]').attr("content")).replace(/&amp;/g, '%26');
                console.log('name:', name);
            }
            if ($('meta[name=tw_contentType]').attr("content")) {
                type = $('meta[name=tw_contentType]').attr("content");
                switch (type.toLowerCase()) {
                    case 'region':
                        tweetUrl = 'https://twitter.com/share?text=' + 'Check out these fun things to do in ' + region + ' Wisconsin from' + ' @TravelWI&url=' + this.url;
                        break;
                    case 'county':
                        tweetUrl = 'https://twitter.com/share?text=' + 'Check out these fun things to do in ' + county + ' from' + ' @TravelWI&url=' + this.url;
                        break;
                    case 'city':
                        tweetUrl = 'https://twitter.com/share?text=' + 'Check out these fun things to do in ' + city + ' from' + ' @TravelWI&url=' + this.url;
                        break;
                    case 'place':
                        tweetUrl = 'https://twitter.com/share?text=' + 'Check out ' + placeName + ' from' + " @TravelWI. Who's with me? %23"
                            + categoryName.split(" ").join('').split("\\-").join('').split("\\/").join('') + '&url=' + this.url;
                        break;
                    case 'event':
                        tweetUrl = 'https://twitter.com/share?text=' + "Now this is my idea of fun! Check out this " + categoryName + " event from @TravelWI&url=" + this.url;
                        break;
                    case 'blog':
                        tweetUrl = 'https://twitter.com/share?text=' + name + ' from @TravelWI&url=' + this.url;
                        break;
                    case 'article':
                        tweetUrl = 'https://twitter.com/share?text=' + name + ' from @TravelWI&url=' + this.url;
                        break;
                    case 'pressrelease':
                        tweetUrl = 'https://twitter.com/share?text=' + 'Check out this press release from @TravelWI&url=' + this.url;
                        break;
                    case 'page':
                        if (name.toLowerCase() === "the big bundle up") {
                            tweetUrl = 'https://twitter.com/share?text=' + 'Help keep %23Wisconsin warm this winter by donating warm clothes to the @TravelWI %23BigBundleUp! Details:';
                            break;
                        }
                        else if (name.toLowerCase() === "directory") {
                            var parts = encodeURI(this.url).split("/");
                            var updatedName = parts[parts.length - 2];
                            parts = updatedName.split("-");
                            updatedName = "";
                            parts.forEach(function (word) {
                                word = word.charAt(0).toUpperCase() + word.slice(1);
                                updatedName += word + " ";
                            });
                            tweetUrl = 'https://twitter.com/share?text=' + 'Planning a trip to %23Wisconsin? Read about ' + updatedName.trim() + ' from @TravelWI&url=' + this.url;
                            break;
                        }
                        else if (name.toLowerCase() === "supper club showdown") {
                            tweetUrl = 'https://twitter.com/share?text=' + 'I just voted for my favorite Wisconsin supper club in the @TravelWI Supper Club Showdown. Cast your vote at:';
                            break;
                        }
                        else if (name.toLowerCase() === "packers dream draft sweepstakes") {
                            tweetUrl = 'https://twitter.com/share?text=' + 'I just entered to win %23Packers tickets and sideline passes in the @TravelWI Dream Draft Sweepstakes. Enter Now:';
                            break;
                        }
                        else if (name.toLowerCase() === "soak up the fun") {
                            tweetUrl = 'https://twitter.com/share?text=' + 'I just entered to win an amazing @TravelWI vacation in the Soak Up the Fun Sweepstakes! Enter Now:';
                            break;
                        }
                        else if (name.toLowerCase() === "fish fry face-off") {
                            tweetUrl = 'https://twitter.com/share?text=' + 'There’s fried fish, and then there’s Wisconsin fish fry! 🍤 Check out the top fan-nominated fish frys in %23Wisconsin. %23FishFryFaceoff %23TravelWI @TravelWI&url=' + this.url;
                            break;
                        }
                        else if (name.toLowerCase() === "great wisconsin getaway") {
                            tweetUrl = 'https://twitter.com/share?text=' + 'Win a Great Wisconsin Getaway from @TravelWI for a future trip. ✨ Enter daily to win, now through July. %23TravelWI @TravelWI&url=' + this.url;
                            break;
                        }
                        else if (name.toLowerCase() === "wisconsin brewdown") {
                            tweetUrl = 'https://twitter.com/share?text=' + '🍺 Cheers to %23Wisconsin beers! 🍺 %23WisconsinBeer %23Breweries %23TravelWI @travelwi&url=' + this.url;
                            break;
                        }
                        tweetUrl = 'https://twitter.com/share?text=' + 'Planning a trip to %23Wisconsin? Read about ' + name + ' from @TravelWI&url=' + this.url;
                        break;
                    case 'emailsignup':
                        tweetUrl = 'https://twitter.com/share?text=' + 'Planning a trip to %23Wisconsin? Sign-up for free e-mail updates from @TravelWI&url=' + this.url;
                        break;
                    case 'maps':
                        tweetUrl = 'https://twitter.com/share?text=' + "I might get lost, but at least I'll be in %23Wisconsin! Download maps from @TravelWI here: " + '&url=' + this.url;
                        break;
                    case 'guides':
                        tweetUrl = 'https://twitter.com/share?text=' + 'You know who knows how to have a good time? %23Wisconsin. Click here to download travel guides from @TravelWI&url=' + this.url;
                        break;
                    case 'deals':
                        tweetUrl = 'https://twitter.com/share?text=' + "Great travel. Great deals. What’s not to love? Check out these packages from @TravelWI. " + '&url=' + this.url;
                        break;
                    case 'quiz':
                        var posMatchIt = this.url.indexOf('match-it-wisconsin');
                        var posWhereInWisco = this.url.indexOf('where-in-wisco');
                        //console.log('url', this.url);
                        //console.log('posWhereInWisco', posWhereInWisco);
                        if(posMatchIt >= 0) {
                            tweetUrl = 'https://twitter.com/share?text=' + 'How well do you remember Wisconsin? Share your score and time! @TravelWI #MatchItWisconsin #TravelWI' + '&url=' + this.url;
                        } else if(posWhereInWisco >= 0) {
                            tweetUrl = 'https://twitter.com/share?text=' + 'How well do you know Wisconsin? Share your score! @TravelWI #WhereInWisco #TravelWI' + '&url=' + this.url;
                        } else{
                            var quizScore = $('meta[name=tw_quizScore]').attr('content');
                            tweetUrl = 'https://twitter.com/share?text=' + 'I got ' + quizScore + '%25 on Travel Wisconsin\'s Fest or Fiction game. Try it yourself for a chance to win prizes!' + '&url=' + this.url;
                        }
                       //console.log('tweetUrl', tweetUrl);
                        break;
                    default:
                        var newName = Wdot.Share.nameDecode(name);
                        tweetUrl = 'https://twitter.com/share?text=' + newName + ' from @TravelWI&url=' + this.url;
                        break;
                }
            }
            Wdot.Share.trackShareEvent("Twitter", "Tweet", decodeURIComponent(this.url));
            Wdot.Share.windowOpen(tweetUrl);
            Wdot.Share.shareClose();
        };
        Share.pin = function () {
            Wdot.Share.trackShareEvent("Pintrest", "Pin", decodeURIComponent(this.url));
            $('.pinterestButton').children()[0].click();
            Wdot.Share.shareClose();
        };
        ;
        Share.facebookShare = function () {
            //var shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + self.url;
            var shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + this.url;
            Wdot.Share.trackShareEvent("Facebook", "Share", decodeURIComponent(this.url));
            Wdot.Share.windowOpen(shareUrl);
            Wdot.Share.shareClose();
        };
        Share.google = function () {
            var shareUrl = 'https://plus.google.com/share?url=' + this.url;
            Wdot.Share.trackShareEvent("Google", "Share", decodeURIComponent(this.url));
            Wdot.Share.windowOpen(shareUrl);
        };
        Share.MediaGalleryEmail = function (url, name) {
            if (url.substring(0, 1) == '~')
                url = url.substring(1);
            url = 'https://' + window.location.hostname + url;
            if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                Wdot.ModalHelpWindow.loadAjaxGet(300, 400, true, '/Help/EmailShare?referenceURL=' + url, function () {
                    document.getElementById("ScreenHeight").value = screen.height.toString();
                    document.getElementById("ScreenWidth").value = screen.width.toString();
                    document.getElementById("PageTitle").value = name + " | Travel Wisconsin";
                }, null, null);
            }
            else {
                Wdot.ModalHelpWindow.loadAjaxGet(500, 800, true, '/Help/EmailShare?referenceURL=' + url, function () {
                    document.getElementById("ScreenHeight").value = screen.height.toString();
                    document.getElementById("ScreenWidth").value = screen.width.toString();
                    document.getElementById("PageTitle").value = name + " | Travel Wisconsin";
                }, null, null);
            }
            Wdot.Share.trackShareEvent("Email", "Share", decodeURIComponent(this.url));
        };
        Share.MediaGalleryTweet = function (url, name) {
            if (url.substring(0, 1) == '~')
                url = url.substring(1);
            name = Wdot.Share.nameDecode(name);
            var tweetUrl = 'https://twitter.com/share?text=' + name + ' from @TravelWI&url=' + 'https://' + window.location.hostname + url;
            Wdot.Share.trackShareEvent("Twitter", "Tweet", decodeURIComponent(this.url));
            Wdot.Share.windowOpen(tweetUrl);
        };
        Share.MediaGalleryPin = function (url, fileLocation, name) {
            if (url.substring(0, 1) == '~')
                url = url.substring(1);
            name = name + " from Travel Wisconsin";
            name = Wdot.Share.nameDecode(name);
            var shareUrl = '//www.pinterest.com/pin/create/button/?url=' + 'https://' + window.location.hostname + url +
                '&media=' + 'https://' + window.location.hostname + fileLocation.substring(1) + '&description=' + name;
            Wdot.Share.trackShareEvent("Pintrest", "Pin", decodeURIComponent(this.url));
            Wdot.Share.windowOpen(shareUrl);
        };
        Share.MediaGalleryFacebook = function (url) {
            if (url.substring(0, 1) == '~')
                url = url.substring(1);
            var shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + 'https://' + window.location.hostname + url;
            Wdot.Share.windowOpen(shareUrl);
        };
        Share.MediaGalleryGoogle = function (url) {
            if (url.substring(0, 1) == '~')
                url = url.substring(1);
            var shareUrl = 'https://plus.google.com/share?url=' + 'https://' + window.location.hostname + url;
            Wdot.Share.trackShareEvent("Google", "Share", decodeURIComponent(this.url));
            Wdot.Share.windowOpen(shareUrl);
        };
        Share.windowOpen = function (windowUrl) {
            window.open(windowUrl, 'sharer', 'width=626,height=436');
        };
        Share.nameDecode = function (name) {
            name = name.replace(/&amp;/g, '%26').replace(/&quot;/g, '%22').replace(/&#39;/g, '%27');
            return name;
        };
        ;
        Share.trackShareEvent = function (socialNetwork, action, url) {
            ga('send', {
                hitType: 'social',
                socialNetwork: socialNetwork,
                socialAction: action,
                socialTarget: url
            });
        };
        return Share;
    }());
    // console.log('Share.js()');
    // console.log('location: ', location.href);
    Share.pageTitle = encodeURIComponent($('title').text());
    Share.url = encodeURIComponent(location.href).toLowerCase();
    // console.log('Share.url: ', Share.url);
    // console.log('Share.pageTitle: ', Share.pageTitle);
    Wdot.Share = Share;
})(Wdot || (Wdot = {}));
//# sourceMappingURL=Share.js.map